export const NOMINATIM_URL = process.env.EXPO_PUBLIC_NOMINATIM_URL;
